<template>
  <div class="preview-page">
    <!-- 纯展示页：无任何操作按钮 -->

    <div v-if="error" class="pv-error">
      <i class="el-icon-warning"></i>
      <p>{{ error }}</p>
    </div>

    <div v-else class="pv-card">
      <!-- 标题 -->
      <h1 class="pv-title">{{ title }}</h1>

      <!-- 统计（文本行，对齐老系统） -->
      <div v-if="showNum" class="pv-stats">
        <template v-if="type === 'quote'">
          <span class="pv-stat-item">总名额：<span class="pv-stat-num pv-stat-hl">{{ totalNum }}</span></span>
          <span class="pv-stat-item">已申请名额：<span class="pv-stat-num pv-stat-hl">{{ indexNum }}</span></span>
          <span class="pv-stat-item">剩余名额：<span class="pv-stat-num pv-stat-hl">{{ surNum }}</span></span>
        </template>
        <template v-else>
          <span class="pv-stat-item">兼职单数：<span class="pv-stat-num">{{ totalNum }}</span></span>
          <span class="pv-stat-item">已审核：<span class="pv-stat-num">{{ indexNum }}</span></span>
        </template>
      </div>

      <!-- 明细 -->
      <div class="pv-table-wrap">
        <table class="pv-table">
          <thead>
            <tr>
              <th v-for="c in columns" :key="c.key">{{ c.label }}</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="row in list" :key="row.id">
              <td v-for="c in columns" :key="c.key">{{ cellText(c.key, row) }}</td>
            </tr>
            <tr v-if="list.length === 0">
              <td :colspan="columns.length" class="pv-empty">暂无数据</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
import { previewData } from '@/api/tool'

const COL_DEFS = {
  quote: {
    name: '姓名',
    phone: '手机号',
    content: '申请内容',
    apply_status_text: '申请状态',
    approval_status_text: '审核结果',
    create_time: '申请时间'
  },
  work: {
    name: '项目名称',
    price: '项目价格',
    status_text: '项目状态',
    create_time: '发布时间'
  }
}

export default {
  name: 'PreviewPage',
  data() {
    return {
      type: 'quote',
      title: '',
      showNum: 1,
      totalNum: 0,
      indexNum: 0,
      surNum: 0,
      columns: [],
      list: [],
      error: ''
    }
  },
  created() {
    this.parse()
    this.load()
  },
  methods: {
    parseInt(v, def) {
      const n = parseInt(v)
      return isNaN(n) ? def : n
    },
    parse() {
      const q = this.$route.query
      this.type = this.$route.params.type === 'work' ? 'work' : 'quote'
      this.title = q.title || (this.type === 'quote' ? '名额申请表' : '兼职单')
      this.showNum = this.parseInt(q.showNum, 1) === 1
      this.totalNum = this.parseInt(q.totalNum, 0)
      this.indexNum = this.parseInt(q.indexNum, 0)
      this.surNum = this.parseInt(q.surNum, 0)
      // 显示列
      const defs = COL_DEFS[this.type]
      const keys = (q.t || '').split(',').filter(k => defs[k])
      this.columns = keys.length ? keys.map(k => ({ key: k, label: defs[k] })) : Object.keys(defs).map(k => ({ key: k, label: defs[k] }))
    },
    load() {
      const q = this.$route.query
      previewData({ type: this.type, company_id: q.company_id, token: q.token })
        .then(data => { this.list = data.list || [] })
        .catch(err => {
          this.error = (err && err.message) || '数据加载失败'
        })
    },
    reload() {
      this.error = ''
      this.load()
    },
    fmtDateTime(ts) {
      if (!ts) return '—'
      const d = new Date(parseInt(ts) * 1000)
      const p = n => (n < 10 ? '0' + n : '' + n)
      return `${d.getFullYear()}-${p(d.getMonth() + 1)}-${p(d.getDate())} ${p(d.getHours())}:${p(d.getMinutes())}`
    },
    fmtMoney(n) {
      return parseFloat(n || 0).toLocaleString('zh-CN', { minimumFractionDigits: 2, maximumFractionDigits: 2 })
    },
    cellText(key, row) {
      if (key === 'create_time') return this.fmtDateTime(row.createtime)
      if (key === 'price') return '¥ ' + this.fmtMoney(row.price)
      return row[key] || '—'
    }
  }
}
</script>

<style scoped>
.preview-page {
  min-height: 100vh;
  background: #f5f5f5;
  padding: 20px;
  box-sizing: border-box;
}

.pv-error {
  max-width: 880px; margin: 80px auto; text-align: center;
  color: #ED4010; font-size: 15px;
}
.pv-error i { font-size: 36px; }

.pv-card {
  max-width: 880px;
  margin: 0 auto;
  background: #fff;
  padding: 42px 71px;
  box-sizing: border-box;
}

.pv-title {
  margin: 0 0 42px;
  text-align: center;
  font-size: 34px;
  font-weight: 700;
  color: #000;
  line-height: 51px;
}

.pv-stats {
  font-size: 14px;
  font-weight: 700;
  color: #000;
  margin: 0 0 42px;
  display: flex;
}
.pv-stat-item { margin: 0 28px; }
.pv-stat-num { font-weight: 700; }
.pv-stat-num.pv-stat-hl { color: #ED4010; }

.pv-table-wrap { overflow-x: auto; }
.pv-table { width: 100%; border-collapse: collapse; table-layout: fixed; }
.pv-table th {
  background: #fff;
  color: #909399;
  font-weight: 600;
  font-size: 14px;
  text-align: left;
  padding: 8px 12px;
  border-bottom: 1px solid #EBEEF5;
}
.pv-table td {
  padding: 8px 12px;
  font-size: 14px;
  color: #606266;
  border-bottom: 1px solid #EBEEF5;
}
.pv-empty { text-align: center; color: #B4BDCF; }
</style>